import { ADD_CONSULTANT, ADD_FILE_CHARGE, BILL_HISTORY, DELETE_CONSULTANT, DELETE_FILE_CHARGE, DOWNLOAD_BILL, DOWNLOAD_VOUCHER, FINAL_BILL, FINAL_BILL_BY_TYPE, FINAL_BILL_DATA, FINAL_BILL_DELETE, FINAL_BILL_OTP, GET_ALL_SERVICES, GET_CONSULTANT, GET_CONSULTANT_BY_ID, GET_DOWNLOAD_BILL, GET_FILE_CHARGE, GET_REFERRAL_DATA, GET_VOUCHER_BILL, SEARCH_ALL_SERVICES, SEARCH_FINAL_BILL, UPDATE_CONSULTANT, UPDATE_FILE_CHARGE, VOUCHER_DATA, VOUCHER_SEATING } from "../actions/Account.action";

const initialState = {
    addConsultant: '',
    getConsultant: '',
    getConsultantById: '',
    deleteConsultant: '',
    updateConsultant: '',
    getAllServices: '',
    voucherSeating: '',
    voucherData: '',
    finalBill: '',
    finalBillData: '',
    finalBillByType: '',
    billHistory: '',
    addFileCharge:'',
    updateFileCharge:'',
    deleteFileCharge:'',
    getFileCharge:'',
    downloadVoucher:'',
    downloadBill:'',
    getDownloadBill:'',
    getVoucherBill:'',
    finalBillOtp:'',
    finalBillDelete:'',
    getReferralData:''
}

const accountReducer = (state = initialState, action) => {
    switch (action.type) {
        case ADD_CONSULTANT:
            return { ...state, addConsultant: action.payload };
        case GET_CONSULTANT:
            return { ...state, getConsultant: action.payload };
        case GET_CONSULTANT_BY_ID:
            return { ...state, getConsultantById: action.payload };
        case DELETE_CONSULTANT:
            return { ...state, deleteConsultant: action.payload };
        case UPDATE_CONSULTANT:
            return { ...state, updateConsultant: action.payload };
        case GET_ALL_SERVICES:
            return { ...state, getAllServices: action.payload };
        case SEARCH_ALL_SERVICES:
            return { ...state, getAllServices: action.payload };
        case VOUCHER_SEATING:
            return { ...state, voucherSeating: action.payload };
        case VOUCHER_DATA:
            return { ...state, voucherData: action.payload };
        case FINAL_BILL:
            return { ...state, finalBill: action.payload };
        case FINAL_BILL_DATA:
            return { ...state, finalBillData: action.payload };
        case FINAL_BILL_BY_TYPE:
            return { ...state, finalBillByType: action.payload };
        case BILL_HISTORY:
            return { ...state, billHistory: action.payload };
        case ADD_FILE_CHARGE:
            return { ...state, getFileCharge: action.payload };
        case UPDATE_FILE_CHARGE:
            return { ...state, getFileCharge: action.payload };
        case DELETE_FILE_CHARGE:
            return { ...state, getFileCharge: action.payload };
        case GET_FILE_CHARGE:
            return { ...state, getFileCharge: action.payload };
        case DOWNLOAD_VOUCHER:
            return { ...state, downloadVoucher: action.payload };
        case SEARCH_FINAL_BILL:
            return { ...state, finalBillByType: action.payload };
        case DOWNLOAD_BILL:
            return { ...state, downloadBill: action.payload };
        case GET_DOWNLOAD_BILL:
            return { ...state, getDownloadBill: action.payload };
        case GET_VOUCHER_BILL:
            return { ...state, getVoucherBill: action.payload };
        case FINAL_BILL_OTP:
            return { ...state, finalBillOtp: action.payload };
        case FINAL_BILL_DELETE:
            return { ...state, finalBillDelete: action.payload };
        case GET_REFERRAL_DATA:
            return { ...state, getReferralData: action.payload };
        default:
            return state;
    }
}

export default accountReducer;